import { useCallback, useState } from 'react';
import { format, addDays } from 'date-fns';

import timeEntryService from '../../../services/timeEntryService';
import { toApiDateTime } from '../../../utils/dateUtils';

export default function useTimeEntries({ labourerId, projectId, selectedType, dateRange, page, perPage, onError }) {
  const [timeEntries, setTimeEntries] = useState([]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchTimeEntries = useCallback(async () => {
    setIsLoading(true);

    try {
      const payload = {};

      if (labourerId) payload.labourerId = labourerId;
      if (projectId) payload.projectId = projectId;

      if (selectedType) payload.type = selectedType.value;

      if (dateRange) {
        // This picker returns [startOfFirstDay, endOfLastDay] (confirmed via
        // react-calendar's getValueRange: getEnd('day', ...) = next day start - 1ms),
        // not an exclusive next-day boundary. Formatting endOfLastDay to 'yyyy-MM-dd'
        // yields the last selected day itself, so add a day to get the exclusive
        // boundary the API's $lte comparison expects — otherwise a single-day
        // selection produces a zero-width window and the last day of any range
        // is silently dropped.
        if (dateRange[0]) payload.startTime = toApiDateTime(format(dateRange[0], 'yyyy-MM-dd'));
        if (dateRange[1]) payload.endTime = toApiDateTime(format(addDays(dateRange[1], 1), 'yyyy-MM-dd'));
      }

      if (page) payload.page = page;
      if (perPage) payload.perPage = perPage;

      const { timeEntries, count } = await timeEntryService.fetchTimeEntries(payload);

      setTimeEntries(timeEntries);
      setCount(count);
    } catch (error) {
      console.log(error);
      onError?.(error);
    } finally {
      setIsLoading(false);
    }
  }, [labourerId, projectId, selectedType, dateRange, page, perPage, onError]);

  return {
    timeEntries,
    count,
    isLoading,
    fetchTimeEntries,
  };
};